import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';

@Component({
  standalone: false,
  selector: 'app-security-banner',
  templateUrl: './security-banner.component.html',
  styleUrls: ['./security-banner.component.scss']
})
export class SecurityBannerComponent implements OnInit {

  @Input() button: boolean;
  showIcons: boolean;

  constructor(private r: Router, private commonService: CommonsService) { }

  ngOnInit() {
    this.showIcons = this.button;
  }

  goToUrl = () => {
    this.commonService.eventsAnalitics('click', 'content', 'Security');
    this.r.navigateByUrl('security');
  }
}
